import { __generator } from "tslib";
import { all, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getPostStreamIdFromMediaSource } from '../helpers';
import { DEVIATIONS_PER_FETCH } from '../constants';
function handleInitPostStream(action) {
    var mediaSource, streamId, isStreamInitialized;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                mediaSource = action.payload;
                if (!mediaSource) {
                    return [2 /*return*/];
                }
                streamId = getPostStreamIdFromMediaSource(mediaSource);
                return [4 /*yield*/, select(selectors.isInitialized, streamId)];
            case 1:
                isStreamInitialized = _a.sent();
                if (isStreamInitialized) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, all([
                        put(withOffset.actions.initialize({
                            streamId: streamId,
                            itemsPerFetch: DEVIATIONS_PER_FETCH,
                            streamParams: {
                                type: mediaSource,
                            },
                        })),
                        put(withOffset.actions.fetch(streamId)),
                    ])];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default handleInitPostStream;
//# sourceMappingURL=initPostStream.js.map